module.exports = __webpack_public_path__ + "static/img/4.05d05118.jpg";